<template>
    <section-flavors v-if="flavors.length && !isProductUnavailable" id="flavors">
        <secondary-title>Sabores</secondary-title>
        <ul class="flavors">
            <li
                v-for="flavor in flavors"
                :key="flavor.id"
                :class="[
                    'flavors__item',
                    flavor.active && 'flavors__item--active',
                    flavor.disabled && 'flavors__item--disabled'
                ]"
                :title="flavor.disabled && textDisabledFlavor()"
            >
                <figure v-if="flavor.path_image" class="photo">
                    <img
                        :src="flavor.path_image"
                        :alt="'Sabor ' + flavor.name.toLowerCase()"
                        loading="lazy"
                        class="photo__img"
                    />
                </figure>
                <div class="flavor">
                    <div>
                        <h3 class="flavor__name">{{ flavor.name }}</h3>
                        <p
                            class="flavor__description"
                            :title="flavor.description"
                        >
                            {{ flavor.description }}
                        </p>
                        <p class="flavor__price">
                            {{ currency.money(flavor.price) }}
                        </p>
                    </div>
                    <div
                        @click="activeFlavor(flavor)"
                        :class="[
                            'flavor__select',
                            flavor.active && 'flavor__select--active'
                        ]"
                    >
                        <i class="fas fa-check"></i>
                    </div>
                </div>
            </li>
        </ul>

        <div
            class="mb-2 mt-2 d-flex flex-wrap align-items-center justify-content-center justify-content-sm-end"
            style="min-width: 240px"
            v-if="hidePrice == false"
        >
            <c-button
                :backgroundColor="
                    $root.$children[0].theme.products.button.background_color
                "
                :backgroundColorHover="
                    $root.$children[0].theme.products.button
                        .background_color_hover
                "
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="
                    $root.$children[0].theme.products.button.color_hover
                "
                :borderColor="
                    $root.$children[0].theme.products.button.border_color
                "
                :borderColorHover="
                    $root.$children[0].theme.products.button.border_color_hover
                "
                :borderRadius="
                    $root.$children[0].theme.products.button.border_radius
                "
                :textTransform="
                    $root.$children[0].theme.products.button.text_transform
                "
                display="flex"
                class="paction add-cart mb-1"
                @click.prevent="addCart"
            >
                <span style="font-size: 1.4rem; min-width: 15rem;"
                    >Adicionar ao carrinho</span
                >
            </c-button>
            <c-button
                :backgroundColor="
                    $root.$children[0].theme.products.button.background_color
                "
                :backgroundColorHover="
                    $root.$children[0].theme.products.button
                        .background_color_hover
                "
                :color="$root.$children[0].theme.products.button.color"
                :colorHover="
                    $root.$children[0].theme.products.button.color_hover
                "
                :borderColor="
                    $root.$children[0].theme.products.button.border_color
                "
                :borderColorHover="
                    $root.$children[0].theme.products.button.border_color_hover
                "
                :borderRadius="
                    $root.$children[0].theme.products.button.border_radius
                "
                :textTransform="
                    $root.$children[0].theme.products.button.text_transform
                "
                display="flex"
                class="paction py-1 px-5 mb-1"
                @click.prevent="addCart(true)"
            >
                {{
                    company.finalizacao_pagamento.tipo == "PAGAMENTO"
                        ? isBudgetLayout
                            ? "Orçar"
                            : "Comprar"
                        : "Orçamento"
                }}
            </c-button>
        </div>
    </section-flavors>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { CSecondaryTitle } from "../Styles/Components/styled";
import Currency from "../../helpers/parseCurrency";
import { CSectionFlavors } from "../Styles/Product/styled";
import { CButton } from "../Styles/Button/styled";

export default {
    name: "ProductFlavors",
    components: {
        "secondary-title": CSecondaryTitle,
        "section-flavors": CSectionFlavors,
        "c-button": CButton
    },
    data() {
        return {
            currency: Currency,
            company: this.$root.$children[0].$attrs.company
        };
    },
    methods: {
        addCart(redirect_cart = false) {
            let data = {
                quantity: this.quantity,
                redirect_cart: redirect_cart
            };
            this.$emit("addCart", data);
        },
        activeFlavor(flavor) {
            flavor.active = !flavor.active;
            if (
                this.maximumAmountOfFlavorsToSelect && 
                this.flavors.filter(el => el.active).length ===
                Number(this.maximumAmountOfFlavorsToSelect)
            ) {
                this.flavors
                    .filter(el => !el.active)
                    .map(el => (el.disabled = true));
            } else {
                this.flavors
                    .filter(el => !el.active && el.disabled)
                    .map(el => (el.disabled = false));
            }
        },
        textDisabledFlavor() {
            return this.maximumAmountOfFlavorsToSelect ? `Você pode selecionar até ${
                this.maximumAmountOfFlavorsToSelect
            } ${
                Number(this.maximumAmountOfFlavorsToSelect) > 1
                    ? "sabores"
                    : "sabor"
            }!` : '';
        }
    },
    computed: {
        ...mapState("products", ["flavors"]),
        ...mapGetters("products", [
            "maximumAmountOfFlavorsToSelect",
            "isProductUnavailable"
        ]),
        hidePrice() {
            let hide =
                this.company?.settings?.hide_price_not_logged_user ?? false;
            return hide === false
                ? false
                : hide === true && this.isLogged === false
                ? true
                : false;
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged;
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false;
        }
    }
};
</script>
